.kdx-text-callout {
	text-align: center;
	margin: 40px 0;

	&__subheading {
		margin: 0 0 8px 0;
	}
	&__heading {
		position: relative;
		padding-bottom: 16px;
		margin: 0 0 24px 0;
	
		&::after {
			content: '';
			width: 100%;
			max-width: 65px;
			height: 4px;
			background: $sectionTitleBorderColor;
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translateX(-50%);			
		}
	}
	&__content {		

		* {
			margin: 0;
			padding: 0;

			&:last-of-type {
				padding-bottom: 0;
			}

			& + * {
				margin-top: 10px;
			}
		}
	}

	&__action {
		margin-top: 25px;
	}
	&.left-aligned {
		text-align: left;

		.kdx-text-callout__heading {

			&::after {
				left: 0;
				transform: none;
			}
		}
	}
}




@include media-breakpoint-down(md) {
	.kdx-text-callout {
		margin: 48px 0;

		&__content {
			@include text-size(14);
			@include line-height(22);
		}		
	}
}




@include media-breakpoint-down(sm) {
	.kdx-text-callout {
		
		&__action {

			.btn { min-width: 80%; }
		}
	}
}	